import { render, staticRenderFns } from "./cargoDepartmentNewSelect.vue?vue&type=template&id=120be042&"
import script from "./cargoDepartmentNewSelect.vue?vue&type=script&lang=js&"
export * from "./cargoDepartmentNewSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('120be042')) {
      api.createRecord('120be042', component.options)
    } else {
      api.reload('120be042', component.options)
    }
    module.hot.accept("./cargoDepartmentNewSelect.vue?vue&type=template&id=120be042&", function () {
      api.rerender('120be042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoDepartmentNewSelect.vue"
export default component.exports